import { useGetActionsApps } from "@queries/actions-apps/useGetActionsApps";
import { useAuth } from "@shared/hooks/useAuth";

export const useGoogleContactsAccess = () => {
  const { user } = useAuth();
  const connectedAppsQuery = useGetActionsApps();

  const googleApp = connectedAppsQuery.data?.find(
    (app) => app.id === "google",
  );
  const isConnected = googleApp?.connection === "connected";
  const hasConsent =
    user.communicationPreferences.googleEmailContactsExtraction?.isEnabled ??
    false;

  return {
    isLoading: connectedAppsQuery.isLoading,
    isError: connectedAppsQuery.isError,
    isConnected,
    hasConsent,
    hasAccess: isConnected && hasConsent,
  };
};
